function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CoreLocaleKeys } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { retrieveOfferingContextQuickView } from '../../../../../reducers/actions/offering.order.actions';
import { IsRetrievingOfferingContextQuickView, OfferingQuickViewSelector, QuickViewSummaryTabViewModel, RetrieveOfferingContextQuickViewErrorSelector } from '../../../../../reducers/selectors/offering.order.selectors';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    isRetrievingOfferingContextQuickView: IsRetrievingOfferingContextQuickView(store),
    offeringContext: OfferingQuickViewSelector(store),
    retrieveOfferingContextQuickViewError: RetrieveOfferingContextQuickViewErrorSelector(store),
    summaryTabViewModel: QuickViewSummaryTabViewModel(store)
  };
};
var controllerActions = {
  retrieveOfferingContextQuickView: retrieveOfferingContextQuickView
};
var TRUNCATION_PREFIX = '...';
var DESCRIPTION_LENGTH_LIMIT = 175;
var QuickViewPopupController = /*#__PURE__*/function () {
  function QuickViewPopupController($ngRedux) {
    _classCallCheck(this, QuickViewPopupController);
    this.$ngRedux = $ngRedux;
    this.disconnectRedux = null;
    this.truncationPrefix = TRUNCATION_PREFIX;
  }
  return _createClass(QuickViewPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.showDescriptionOverflow = false;
      this.descriptionLengthLimit = DESCRIPTION_LENGTH_LIMIT;
      this.customerCareLocaleKeys = CustomerCareLocaleKeys;
      this.coreLocaleKeys = CoreLocaleKeys;
      this.handleClose = function () {
        _this.onClose()();
      };
      this.onSelect = function () {
        _this.onSelectOffer()(_this.offer.Id);
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.$onDestroy = function () {
        _this.disconnectRedux();
      };
      this.actions.retrieveOfferingContextQuickView(this.offer.Id);
      this.toggleDescriptionOverflow = function () {
        _this.showDescriptionOverflow = !_this.showDescriptionOverflow;
        _this._updateDescriptionLengthLimit();
      };
      this._updateDescriptionLengthLimit = function () {
        _this.descriptionLengthLimit = _this.showDescriptionOverflow ? _this.offer.ShortDescription.length : DESCRIPTION_LENGTH_LIMIT;
      };
    }
  }]);
}();
export default {
  template: require('./quickView.popup.html'),
  controller: QuickViewPopupController,
  controllerAs: 'quickViewPopupController',
  bindings: {
    offer: '<',
    onClose: '&',
    onSelectOffer: '&'
  }
};